<template>
  <b-card header-tag="header" class="m-3" no-body>
    <template #header>
      <header-sagres :titulo="tituloCard" :botoes="botoesHeader" breakpoint="xl" />
    </template>
    <b-tabs card fill>
      <b-tab>
        <template #title>
          <font-awesome-icon icon="address-card" class="mr-1 text-success" v-b-tooltip.hover title="Dados Pessoais" />
          <span class="d-none d-md-inline">Dados pessoais</span>
        </template>
        <AbaEditarDadosPessoaisUsuario v-if="usuario" :usuario="usuario" @dadosAtualizados="atualizarPropUsuario"
          @idAtualizado="atualizarIdUsuario" />
      </b-tab>
      <b-tab lazy>
        <template #title>
          <font-awesome-icon icon="building-flag" class="mr-1 text-warning" v-b-tooltip.hover title="Permissões" />
          <span class="d-none d-md-inline">Permissões</span>
        </template>
        <AbaEditarDadosPermissoesUsuario :usuario="usuario" @evento-mudanca-2="atualizarPropUsuario" />
      </b-tab>
      <b-tab lazy>
        <template #title>
          <font-awesome-icon icon="building-flag" class="mr-1 text-warning" v-b-tooltip.hover title="Gestão para UGs" />
          <span class="d-none d-md-inline">Gestão para UGs</span>
        </template>
        <b-alert v-if="usuario?.ID_CRP_MUNICIPIO == null" :show="usuario?.ID_CRP_MUNICIPIO == null" variant="warning">
          Você não pode acessar essa aba pois o usuário não está vinculado a um município, por favor retorne a aba de
          dados
          pessoais e adicione um município.
        </b-alert>
        <div v-else>
          <AbaEditarGestorPorUG :usuario="usuario" />
        </div>

      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script lang="ts">
import { UtilsTS } from '@/utilsts';
import { mixins } from 'vue-class-component';
import { Component, Vue } from 'vue-property-decorator';
import HeaderSagres from '@/components/shared/HeaderSagres.vue';
import { BotaoSagres } from '@/types/botao-sagres';
import { Usuario } from '@/types/administracao/usuarios/usuario';
import { store } from "@/store";
import usuarioService from "@/services/administracao/usuarioService";
import AbaEditarDadosPessoaisUsuario from '@/components/administracao/usuarios/AbaEditarDadosPessoaisUsuario.vue'
import AbaEditarDadosPermissoesUsuario from '@/components/administracao/usuarios/AbaEditarDadosPermissoesUsuario.vue'
import AbaEditarGestorPorUG from '@/components/administracao/usuarios/AbaEditarGestorPorUG.vue';
const CompProps = Vue.extend({
  name: 'EditarUsuario',
  components: { AbaEditarDadosPessoaisUsuario, HeaderSagres, AbaEditarDadosPermissoesUsuario, AbaEditarGestorPorUG },
  props: {
    idUsuario: {
      type: String,
      required: true
    }
  }
})

@Component
export default class EditarUsuario extends mixins(UtilsTS, CompProps) {
  botoesHeader: BotaoSagres[] = [
    {
      id: 1,
      icone: 'arrow-left',
      texto: 'Voltar',
      url: `/seguranca-administracao/usuarios`,
    },
  ]

  usuario: Usuario | null = null
  localIdUsuario: string = this.idUsuario; // Propriedade local para manipular o ID

  get tituloCard(): string {
    return this.usuario ? `Usuário ${this.capitalize(this.usuario.NOME)}` : 'Falha ao obter usuário';
  }

  async mounted() {
    this.atualizarPropUsuario();
  }

  async atualizarPropUsuario() {
    try {
      await this.$nextTick();
      store.blockScreen = true;
      this.usuario = null;
      this.usuario = await usuarioService.getUsuarioById(this.localIdUsuario);
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      store.blockScreen = false;
    }
  }

  atualizarIdUsuario(novoId: string) {
    this.localIdUsuario = novoId;
    this.atualizarPropUsuario();
  }
}

</script>

<style scoped></style>